import {
  generateColorRamp,
  howdenWeightedLevels,
} from "../legends/inlandFlood/InlandFloodNatcatWeightedLegend";
export const natcatAnalyticsLayerId = "natcatAnalyticsLayer";
export const natcatAnalyticsDefaultLayer = { id: natcatAnalyticsLayerId, type: "fill" };

const whiteShade = "#FFFFFF";
const blueShades = ["#F7FBFF", "#C8DCF0", "#73B2D8", "#2979B9", "#08306B"];
export const redShades = ["#FFA5A5", "#FF7979", "#FF5353", "#FF2C2C", "#FF0000"];

export const getNatCatAnalyticsInlandTivFillLayer = (field) => ({
  id: natcatAnalyticsLayerId,
  type: "fill",
  paint: {
    "fill-color": [
      "step",
      ["get", field],
      blueShades[0],
      0,
      blueShades[0],
      35,
      blueShades[1],
      150,
      blueShades[2],
      450,
      blueShades[3],
      1500,
      blueShades[4],
    ],
    "fill-opacity": ["step", ["get", field], 0.1, 0, 0.3, 35, 0.5, 150, 0.7, 450, 0.8, 1500, 0.9],
  },
  beforeId: "road-minor",
});

export const getNatCatAnalyticsInlandHex6TivFillLayer = (field) => ({
  id: natcatAnalyticsLayerId,
  type: "fill",
  paint: {
    "fill-color": [
      "step",
      ["get", field],
      blueShades[0],
      3,
      blueShades[0],
      10,
      blueShades[1],
      33,
      blueShades[2],
      100,
      blueShades[3],
      330,
      blueShades[4],
    ],
    "fill-opacity": ["step", ["get", field], 0.1, 1, 0.3, 3, 0.5, 10, 0.7, 33, 0.8, 100, 0.9],
  },
  beforeId: "road-minor",
});

export const getNatCatAnalyticsInlandHex7TivFillLayer = (field) => ({
  id: natcatAnalyticsLayerId,
  type: "fill",
  paint: {
    "fill-color": [
      "step",
      ["get", field],
      blueShades[0],
      1,
      blueShades[0],
      3,
      blueShades[1],
      10,
      blueShades[2],
      33,
      blueShades[3],
      100,
      blueShades[4],
    ],
    "fill-opacity": ["step", ["get", field], 0.1, 1, 0.3, 3, 0.5, 10, 0.7, 33, 0.8, 100, 0.9],
  },
  beforeId: "road-minor",
});

export const natCatAnalyticsInlandHex6TivAndRiskLevelFillLayer = {
  id: natcatAnalyticsLayerId,
  type: "fill",
  paint: {
    "fill-color": [
      "step",
      ["get", "TIVMediumOrHigh"],
      redShades[0],
      3,
      redShades[0],
      10,
      redShades[1],
      33,
      redShades[2],
      100,
      redShades[3],
      330,
      redShades[4],
    ],
    "fill-opacity": ["step", ["get", "TIVMediumOrHigh"], 0.1, 1, 0.2, 3, 0.3, 10, 0.4, 33, 0.5, 100, 0.6],
  },
  beforeId: "road-minor",
};

export const natCatAnalyticsInlandHex7TivAndRiskLevelFillLayer = {
  id: natcatAnalyticsLayerId,
  type: "fill",
  paint: {
    "fill-color": [
      "step",
      ["get", "TIVMediumOrHigh"],
      redShades[0],
      1,
      redShades[0],
      3,
      redShades[1],
      10,
      redShades[2],
      33,
      redShades[3],
      100,
      redShades[4],
    ],
    "fill-opacity": ["step", ["get", "TIVMediumOrHigh"], 0.1, 1, 0.2, 3, 0.3, 10, 0.4, 33, 0.5, 100, 0.6],
  },
  beforeId: "road-minor",
};

export const natCatAnalyticsInlandTivAndInlandRiskFillLayer = {
  id: natcatAnalyticsLayerId,
  type: "fill",
  paint: {
    "fill-color": [
      "step",
      ["get", "TIVMediumOrHigh"],
      whiteShade,
      0,
      whiteShade,
      35,
      redShades[1],
      150,
      redShades[2],
      450,
      redShades[3],
      1500,
      redShades[4],
    ],
    "fill-opacity": ["step", ["get", "TIVMediumOrHigh"], 0.1, 0, 0.2, 35, 0.3, 150, 0.4, 450, 0.5, 1500, 0.6],
  },
  beforeId: "road-minor",
};

function generateShadesAndLevels(numColors) {
  const unscaleFactor = 0.5;
  const shiftFactor = 1;
  // These factors convert [0,18] to [1,10]

  const pairs = generateColorRamp(numColors).map((color, index) => {
    return [index * unscaleFactor + shiftFactor, color];
  });
  const flatList = [whiteShade, ...pairs.flat()];
  return flatList;
}

export const natCatAnalyticsInlandHowdenWeightedFillLayer = {
  id: natcatAnalyticsLayerId,
  type: "fill",
  paint: {
    "fill-color": ["step", ["get", "weighted_howden_rate"], ...generateShadesAndLevels(howdenWeightedLevels)],
  },
  beforeId: "road-minor",
};
